import { Radio } from './Radio';

// TODO: in v9, move styled() from Radio.jsx to here
export var StyledRadio = Radio;